import React from 'react';
// rsuite
import { Message } from 'rsuite';

// styles
import styles from './NotAuthorized.module.less';

export const NotAuthorized = () => {
  return (
    <section className={styles.notAuthorizedContainer}>
      <Message
        className={styles.notAuthorizedMessage}
        showIcon
        type="error"
        title="Access Denied"
        description="Contact your account administrator if you think this is an error."
      />
    </section>
  );
};

export default NotAuthorized;



// WEBPACK FOOTER //
// ./src/components/NotAuthorized/NotAuthorized.jsx